module.exports = __webpack_public_path__ + "img/icon-gold20.9de65641.png";